// src/screens/events/EventsScreen.js
// 78차 63차: 포스터를 첨부해도 목록 카드/상세 화면 어디에도 안 보이던 버그 수정
// (NoticeCard/NoticeDetailView에 렌더링 추가) + 총괄관리자용 공지 수정/삭제 기능 신규
// (WriteNoticeModal이 editingItem을 받으면 updateDoc으로 수정, 상세 화면에 삭제 버튼 추가).
// 49차: notices 컬렉션 없으면 9개 예시 데이터 강제 생성
// 51차: 색 theme.js 단일화 — COLORS 참조 (주황·파랑 이미 정본값)
// 70차: "이벤트" 탭 → "🌟 PICK" 탭으로 명칭 변경 (StoreAdminScreen의 "PICK 테마"와
//       용어 통일 — "이벤트"라는 단어가 항상 할인코드를 줘야 할 것 같은 인상을 줌)
// 70차: 탭 화면 진입 시 기본으로 보이는 탭을 '공지사항' → 'PICK' 탭으로 변경
// 72차: 탭 순서를 PICK > 공지사항 > 앱 소식으로 변경, 각 탭의 용도를 명확히 분리
// 74차: 예시 공지 본문에 남아있던 "ESCAPE ROOM" 표기 → "UNLOCK"으로 통일
// 74차: expiresAt 지난 공지 자동 숨김 추가 — functions/index.js의 onNewStore가 신규 매장
//       입점 안내를 30일 만료로 생성하는데, 기존엔 만료 개념 자체가 없어서 계속 남았음
// 74차: PICK이 예약 탭(BookingScreen.js) 기본 화면으로 옮겨가면서, 일반 고객이 마이 탭에서
//       진입하는 경로는 route.params.hidePick:true로 PICK 탭을 숨김. 총괄관리자 전용 탭
//       (SuperAdminTabNavigator, 파라미터 없이 진입)은 기존처럼 PICK이 그대로 보임 —
//       총괄관리자가 PICK 등록 현황을 볼 필요는 남아있다고 판단해 완전히 안 없앰
//   - PICK: BOOST 계약 매장이 등록한 PICK 테마만 (기존엔 notices의 type:'event' 일반
//     공지도 함께 섞여 있었음 — 제거)
//   - 공지사항: 포인트 부여 이벤트·신규 계약 매장 안내 등 플랫폼 공지 (기존 notices
//     type:'event'를 여기로 흡수 — 'notice'/'event' 두 타입 모두 표시)
//   - 앱 소식: 앱 업데이트를 통한 기능 추가 안내 (변경 없음)
// 75차: 총괄관리자용 공지·소식 작성 기능 추가 — 지금까지 notices 컬렉션은 __DEV__ 시드
//       데이터 외에는 쓸 방법이 전혀 없었음(firestore.rules상 isSuperAdmin() write는
//       이미 허용돼 있었으나 UI가 없었음). 공지사항/앱 소식 탭에 총괄관리자에게만 보이는
//       "+" 작성 버튼과 모달 추가.
// 76차: WriteNoticeModal에 기본 템플릿(NOTICE_TEMPLATES) 추가 — 지금까지 완전 빈 폼이라
//       게시물마다 형식이 제각각이 되기 쉬웠음. 타입 전환 시 아직 안 고친(pristine) 경우만
//       템플릿을 갈아끼우고, "템플릿 불러오기" 버튼으로 언제든 수동 재적용 가능.
// 77차: 마이 탭에서 진입(showBack=true)할 때만 제목("공지·소식") 표시 — 기존엔 이 경로도
//       "‹ 뒤로"만 있는 빈 헤더였음. 하단 탭 경로(showBack 없음)는 원래 로고를 그대로 씀.

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useRoute, useNavigation, useFocusEffect } from '@react-navigation/native';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, FlatList, TouchableOpacity, StyleSheet,
  RefreshControl, Linking, ScrollView, TextInput, Modal,
} from 'react-native';
// 78차 37차: 썸네일 캐싱 없이 매번 재다운로드되던 것 — expo-image로 교체(디스크 캐시 자동)
import { Image } from 'expo-image';
import {
  collection, query, orderBy, getDocs, limit, addDoc, serverTimestamp,
  doc, updateDoc, deleteDoc,
} from 'firebase/firestore';
import * as ImagePicker from 'expo-image-picker';
import * as ImageManipulator from 'expo-image-manipulator';
import { httpsCallable } from 'firebase/functions';
import { useBottomSafePadding } from '../../hooks/useBottomSafePadding';
import { db, functions } from '../../services/firebase';
// 78차 50차: 포스터 업로드/삭제가 uploadAdminImageCF/deleteAdminImageCF 경유로 바뀌면서
// firebase/storage 직접 호출과 storage import 자체가 더 이상 필요 없어짐.
import { useAuth } from '../../contexts/AuthContext';
import { isConfirmedMinorBirth } from '../../utils/dateUtils';
import AppHeader, { RoleBadge } from '../../components/common/AppHeader';
import GradientButton from '../../components/common/GradientButton';
import { SecondaryButton, TextButton } from '../../components/common/Buttons';
import LoadingOverlay from '../../components/common/LoadingOverlay';
import {
  MenuStoreIcon, IconLabel, SpotlightStarIcon, MenuNoticeIcon, RewardIcon,
  EditIcon, CheckmarkIcon, TrashIcon, CrewNoticeIcon,
} from '../../components/common/Icons';
import { LogoMark } from '../../components/common/AppHeader';
import { COLORS } from '../../constants/theme';
import { getGenreMeta, NOTICE_CATEGORIES, getSeatingTypeLabel } from '../../constants';
import { getActivePickStoreEvents, getDday } from '../../services/eventService';
import { getAllStores } from '../../services/productService';

const GOLD = COLORS.gold, BG = COLORS.bg, SURFACE = COLORS.surface;
const BORDER = COLORS.border, TEXT = COLORS.text;
const TEXT_SEC = COLORS.textSec, TEXT_MUTED = COLORS.textMuted;
const ORANGE = COLORS.orange, BLUE = COLORS.blue;

// 70차: 3번째 탭 라벨을 "🎉 이벤트" → "🌟 PICK"으로 변경.
// key는 'event'로 유지 (Firestore type 값·상태 로직과의 하위 호환을 위해 데이터 값은 그대로 둠)
// 72차: 탭 노출 순서를 PICK > 공지사항 > 앱 소식으로 변경
const TABS = [
  { key: 'event',  label: 'PICK',     Icon: SpotlightStarIcon },
  { key: 'notice', label: '공지사항', Icon: MenuNoticeIcon },
  { key: 'news',   label: '앱 소식',  icon: '📰' },
];
// 70차: 개별 게시물(공지/소식/일반 프로모션)에 붙는 배지 라벨.
// 'event' 타입은 실제로 포인트·할인 등 "혜택" 성격의 앱 공지이므로 배지 라벨을
// "이벤트"에서 "혜택"으로 바꿔 오해 소지를 줄임 (BOOST 매장 PICK 카드는 별도 배지 사용)
const TYPE_META = {
  notice: { color: GOLD,   icon: '📢', Icon: MenuNoticeIcon, label: '공지' },
  news:   { color: BLUE,   icon: '📰', label: '소식' },
  event:  { color: ORANGE, icon: '🎁', Icon: RewardIcon, label: '혜택' },
};
const formatDate = ts => {
  if (!ts) return '';
  const d = ts?.toDate ? ts.toDate() : new Date(ts);
  return `${d.getFullYear()}.${String(d.getMonth()+1).padStart(2,'0')}.${String(d.getDate()).padStart(2,'0')}`;
};

const SEED_NOTICES = [
  { type:'notice', pinned:true,
    title:'[필독] 서비스 이용약관 개정 안내',
    summary:'2026년 7월 1일부터 개정된 이용약관이 적용됩니다.',
    body:'안녕하세요, UNLOCK 운영팀입니다.\n\n2026년 7월 1일부터 이용약관이 개정됩니다.\n\n주요 변경사항:\n1. 예약 취소 정책 변경 (예약일 기준 24시간 전까지 무료 취소)\n2. 포인트 유효기간 변경 (적립일로부터 1년)\n3. 개인정보 처리 방침 업데이트' },
  { type:'notice', pinned:false,
    title:'서버 점검 안내 (6월 30일 02:00~04:00)',
    summary:'시스템 안정화를 위한 정기 점검이 진행됩니다.',
    body:'일시: 2026년 6월 30일(화) 새벽 02:00 ~ 04:00\n영향: 앱 전체 서비스 이용 불가\n\n점검 완료 후 정상 서비스가 재개됩니다.' },
  { type:'notice', pinned:false,
    title:'신규 매장 입점 안내 — 강남 미로탈출 스튜디오',
    summary:'강남 지역에 새로운 파트너 매장이 입점했습니다.',
    body:'매장명: 미로탈출 스튜디오 강남점\n위치: 서울 강남구 역삼동\n테마: 공포, 추리, SF\n\n오픈 기념으로 첫 방문 고객에게 10% 할인 혜택을 드립니다.' },
  { type:'news', pinned:false,
    title:'앱 v2.5 업데이트 출시 — 모집 기능 강화',
    summary:'친구 모집 기능이 크게 개선되었습니다.',
    body:'주요 업데이트:\n• 모집 게시판 난이도 필터 추가\n• 빈자리 실시간 알림 기능\n• 예약 확인 화면 UI 개선\n• 버그 수정 및 성능 향상' },
  { type:'news', pinned:false,
    title:'탈출 기록 공유 기능 오픈!',
    summary:'나의 방탈출 기록을 이미지로 저장하고 SNS에 공유할 수 있게 되었습니다.',
    body:'마이페이지 > 탈출 기록 화면에서 📤 버튼을 눌러\n나만의 탈출 스탯 카드를 이미지로 저장하고 SNS에 공유해보세요!' },
  { type:'news', pinned:false,
    title:'즐겨찾기 이벤트 알림 기능 추가',
    summary:'즐겨찾기한 매장의 이벤트 소식을 푸시 알림으로 받아보실 수 있습니다.',
    body:'설정 방법:\n1. 마이페이지 > 즐겨찾기\n2. 원하는 매장 카드의 🔔 이벤트 알림 토글 ON' },
  { type:'event', pinned:true,
    title:'🎉 여름 특별 이벤트 — 2인 예약 시 1만원 할인',
    summary:'7월 한 달간 2인 예약 시 1만원 할인 쿠폰을 증정합니다.',
    body:'이벤트 기간: 2026년 7월 1일 ~ 7월 31일\n혜택: 2인 이상 예약 시 10,000원 할인\n적용 방법: 예약 완료 후 현장에서 앱 화면 제시\n\n* 1인 1회 적용 가능 / 다른 할인과 중복 적용 불가' },
  { type:'event', pinned:false,
    title:'리뷰 작성 포인트 2배 이벤트',
    summary:'6월 30일까지 리뷰 작성 시 100P → 200P 지급!',
    body:'이벤트 기간: 2026년 6월 15일 ~ 6월 30일\n혜택: 리뷰 작성 포인트 100P → 200P\n\n마이페이지 > 내 리뷰 > 작성 가능 탭에서 작성하세요.' },
  { type:'event', pinned:false,
    title:'신규 가입 이벤트 — 500P 즉시 지급',
    summary:'지금 가입하면 500포인트를 즉시 드립니다!',
    body:'지급 조건: 신규 회원가입 완료\n지급 시점: 가입 즉시 자동 지급\n포인트 유효기간: 적립일로부터 1년' },
];

// 49차: notices 컬렉션 자체가 없거나 비어있으면 무조건 시드
// 74차: __DEV__ 가드 추가 — 이전엔 운영 환경에서도 그대로 실행돼 notices가 비어있으면
//       예시 데이터 9개를 프로덕션 DB에 영구 기록하는 하드코딩이었음(CLAUDE.md 규칙 위반).
//       프로덕션에서는 seedIfEmpty가 아무 것도 하지 않으므로, 실제 공지/PICK 데이터는
//       총괄 관리자 화면 등에서 직접 등록해야 함.
let seeded = false;
async function seedIfEmpty() {
  if (!__DEV__) return;
  if (seeded) return;
  try {
    const snap = await getDocs(query(collection(db, 'notices'), limit(1)));
    if (!snap.empty) { seeded = true; return; }
    for (const notice of SEED_NOTICES) {
      await addDoc(collection(db, 'notices'), { ...notice, createdAt: serverTimestamp() });
    }
    seeded = true;
  } catch {}
}

const NoticeCard = ({ item, onPress, isSuperAdmin, onEdit, onDelete }) => {
  const meta = TYPE_META[item.type] || TYPE_META.notice;
  const isPinned = !!item.pinned;
  return (
    <TouchableOpacity style={[nc.wrap, isPinned && nc.pinned]} onPress={() => onPress(item)} activeOpacity={0.82}>
      <View style={nc.top}>
        <View style={[nc.badge, { backgroundColor: meta.color+'22', borderColor: meta.color+'55' }]}>
          {meta.Icon
            ? <IconLabel Icon={meta.Icon} size={12} color={meta.color} textStyle={[nc.badgeText, { color: meta.color }]}>{meta.label}</IconLabel>
            : <Text style={[nc.badgeText, { color: meta.color }]}>{meta.icon} {meta.label}</Text>}
        </View>
        {/* 78차 59차: "공지" 배지 옆 대분류 배지(선택) — 신규매장/휴업안내 등 */}
        {item.category && (
          <View style={[nc.badge, { backgroundColor: 'rgba(255,255,255,0.06)', borderColor: 'rgba(255,255,255,0.16)' }]}>
            <Text style={[nc.badgeText, { color: TEXT_SEC }]}>{item.category}</Text>
          </View>
        )}
        {isPinned && <View style={nc.pinnedBadge}><IconLabel Icon={CrewNoticeIcon} size={10} color={GOLD} gap={3} textStyle={nc.pinnedText}>상단고정</IconLabel></View>}
        <Text style={nc.date}>{formatDate(item.createdAt)}</Text>
        {/* 78차: 카드 목록에서 바로 수정/삭제 — 기존엔 상세 화면까지 들어가야만 가능했음.
            outer TouchableOpacity 안에 중첩된 버튼이라 RN 기본 터치 시스템상 이 버튼을
            누르면 카드 전체(onPress) 대신 이 버튼만 반응함. */}
        {isSuperAdmin && (
          <View style={nc.adminBtns}>
            <TouchableOpacity onPress={(e) => { e.stopPropagation?.(); onEdit(item); }} hitSlop={{ top:8, bottom:8, left:8, right:8 }} style={nc.adminBtn}>
              <EditIcon size={13} color={COLORS.gold} />
            </TouchableOpacity>
            <TouchableOpacity onPress={(e) => { e.stopPropagation?.(); onDelete(item); }} hitSlop={{ top:8, bottom:8, left:8, right:8 }} style={nc.adminBtn}>
              <TrashIcon size={13} color={COLORS.red} />
            </TouchableOpacity>
          </View>
        )}
      </View>
      {/* 78차 63차: 포스터 이미지를 업로드해도 이 목록 카드엔 어디에도 안 보이던 버그 —
          작게라도 썸네일로 노출해 "등록은 됐는데 안 보인다"는 오해를 없앰. */}
      <View style={{ flexDirection: 'row', gap: 10 }}>
        {item.posterImageUrl ? (
          <Image source={{ uri: item.posterImageUrl }} style={nc.thumb} contentFit="cover" />
        ) : null}
        <View style={{ flex: 1 }}>
          <Text style={nc.title} numberOfLines={2}>{item.title}</Text>
          {item.summary ? <Text style={nc.summary} numberOfLines={2}>{item.summary}</Text> : null}
        </View>
      </View>
    </TouchableOpacity>
  );
};
const nc = StyleSheet.create({
  wrap:        { backgroundColor:SURFACE, borderRadius:14, borderWidth:1, borderColor:BORDER, padding:16, marginBottom:10 },
  pinned:      { borderColor:'rgba(212,168,67,0.4)', backgroundColor:'#15152a' },
  top:         { flexDirection:'row', alignItems:'center', gap:6, marginBottom:10, flexWrap:'wrap' },
  badge:       { borderRadius:5, borderWidth:1, paddingHorizontal:8, paddingVertical:3 },
  badgeText:   { fontSize:10, fontWeight:'700' },
  pinnedBadge: { backgroundColor:'rgba(212,168,67,0.12)', borderRadius:5, paddingHorizontal:7, paddingVertical:3, borderWidth:1, borderColor:'rgba(212,168,67,0.3)' },
  pinnedText:  { color:GOLD, fontSize:10, fontWeight:'700' },
  date:        { marginLeft:'auto', color:TEXT_MUTED, fontSize:11 },
  title:       { color:TEXT, fontSize:15, fontWeight:'800', lineHeight:22, marginBottom:6 },
  summary:     { color:TEXT_SEC, fontSize:13, lineHeight:19 },
  thumb:       { width:64, height:64, borderRadius:10, backgroundColor:'#1e1e2c' },
  adminBtns:   { flexDirection:'row', gap:4, marginLeft:8 },
  adminBtn:    { padding:2 },
  adminBtnText:{ fontSize:13 },
});

// 68차 신규: BOOST 플랜 매장이 등록한 이벤트 카드
// 70차: "🏪 매장 이벤트" → "🏪 매장 PICK" 배지로 명칭 변경 (StoreAdminScreen의
// "PICK 테마" 등록 기능과 용어 통일)
// 75차: 썸네일/장르/가격을 추가해 "그냥 텍스트 공지"처럼 보이던 카드를 실제 테마
// 카드에 가깝게 — eventService.getActivePickStoreEvents()가 이미 productId로 테마를
// 찾아 imageUrl/genre/difficulty/minPrice를 붙여서 내려준다.
// 78차 16차: 상세 화면(설명/쿠폰 텍스트) 없이 카드를 누르면 바로 예약 화면(테마 상세)로
// 이동하도록 변경 — 자유입력 "설명"/"쿠폰코드" 표시 제거, 대신 등록 시 고른 고정 태그
// ("특이사항")를 "매장 PICK" 배지 옆에 짧게 노출.
// 78차 58차: 특이사항이 단일 값(highlight)에서 최대 3개 다중선택+직접입력(highlights
// 배열)으로 확장됨에 따라 배지도 여러 개 나란히 표시.
const StoreEventCard = ({ item, onPress }) => {
  const dday = item.endDate ? getDday(item.endDate) : null;
  const gm = item.genre ? getGenreMeta(item.genre) : null;
  return (
    <TouchableOpacity style={sec.wrap} onPress={() => onPress(item)} activeOpacity={0.82}>
      <View style={sec.top}>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
          <View style={sec.storeBadge}>
            <IconLabel Icon={MenuStoreIcon} size={10} color={GOLD} gap={3} textStyle={sec.storeBadgeText}>매장 PICK</IconLabel>
          </View>
          {(item.highlights || []).map(h => (
            <View key={h} style={sec.highlightBadge}>
              <Text style={sec.highlightBadgeText}>{h}</Text>
            </View>
          ))}
        </View>
        {dday ? (
          <View style={sec.ddayBadge}>
            <Text style={sec.ddayText}>{dday}</Text>
          </View>
        ) : null}
      </View>
      <View style={{ flexDirection: 'row', gap: 12 }}>
        {item.imageUrl
          ? <Image source={{ uri: item.imageUrl }} style={sec.thumb} />
          : <View style={[sec.thumb, sec.thumbPlaceholder]}><LogoMark size={20} /></View>}
        <View style={{ flex: 1 }}>
          <Text style={sec.storeName} numberOfLines={1}>{item.storeName}</Text>
          <Text style={sec.title} numberOfLines={2}>{item.title}</Text>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, marginTop: 2 }}>
            {/* 80차 후속: [정책 확정] 배지 순서 — ①형식(방탈출/체험형, 필수) → ②19금 → ③장르 */}
            {item.bookingFormat === 'show' ? (
              <View style={[sec.genreChip, { backgroundColor: COLORS.blue + '26', borderColor: COLORS.blue + '59' }]}>
                <Text style={[sec.genreChipText, { color: COLORS.blue }]}>체험형</Text>
              </View>
            ) : (
              <View style={[sec.genreChip, { backgroundColor: COLORS.teal + '26', borderColor: COLORS.teal + '59' }]}>
                <Text style={[sec.genreChipText, { color: COLORS.teal }]}>방탈출</Text>
              </View>
            )}
            {/* 80차 후속: 체험형 전용 — 단독 대관/합석 뱃지 */}
            {item.bookingFormat === 'show' && (
              <View style={[sec.genreChip, { backgroundColor: COLORS.purple + '26', borderColor: COLORS.purple + '59' }]}>
                <Text style={[sec.genreChipText, { color: COLORS.purple }]}>{getSeatingTypeLabel(item.seatingType)}</Text>
              </View>
            )}
            {item.isAdultOnly && (
              <View style={[sec.genreChip, { backgroundColor: COLORS.dangerBg, borderColor: COLORS.danger + '59' }]}>
                <Text style={[sec.genreChipText, { color: COLORS.danger }]}>19금</Text>
              </View>
            )}
            {gm && (
              <View style={[sec.genreChip, { backgroundColor: gm.color + '26', borderColor: gm.color + '59' }]}>
                <Text style={[sec.genreChipText, { color: gm.color }]}>{item.genre}</Text>
              </View>
            )}
            {/* 80차 후속: 체험형은 1인당 단가로 표기 */}
            {item.bookingFormat === 'show'
              ? (item.pricePerPerson > 0 && <Text style={sec.priceText}>{Number(item.pricePerPerson).toLocaleString()}원 (1인당)</Text>)
              : (item.minPrice != null && <Text style={sec.priceText}>{Number(item.minPrice).toLocaleString()}원~</Text>)}
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
};
const sec = StyleSheet.create({
  wrap:          { backgroundColor:'#15152a', borderRadius:14, borderWidth:1.5, borderColor:'rgba(212,168,67,0.45)', padding:16, marginBottom:10 },
  top:           { flexDirection:'row', alignItems:'center', justifyContent:'space-between', marginBottom:8 },
  storeBadge:    { backgroundColor:GOLD+'22', borderRadius:5, borderWidth:1, borderColor:GOLD+'55', paddingHorizontal:8, paddingVertical:3 },
  storeBadgeText:{ color:GOLD, fontSize:10, fontWeight:'800' },
  // 78차 16차: 등록 시 고른 "특이사항" 고정 태그 — "매장 PICK" 배지 옆에 나란히
  highlightBadge:     { backgroundColor:'rgba(255,255,255,0.06)', borderRadius:5, borderWidth:1, borderColor:'rgba(255,255,255,0.14)', paddingHorizontal:8, paddingVertical:3 },
  highlightBadgeText: { color:TEXT_SEC, fontSize:10, fontWeight:'700' },
  ddayBadge:     { backgroundColor:ORANGE+'20', borderRadius:5, borderWidth:1, borderColor:ORANGE+'50', paddingHorizontal:8, paddingVertical:3 },
  ddayText:      { color:ORANGE, fontSize:10, fontWeight:'800' },
  storeName:     { color:TEXT_MUTED, fontSize:11, fontWeight:'700', marginBottom:4 },
  title:         { color:TEXT, fontSize:15, fontWeight:'800', lineHeight:22, marginBottom:6 },
  thumb:         { width:64, height:64, borderRadius:10, backgroundColor:'#1e1e2c' },
  thumbPlaceholder: { justifyContent:'center', alignItems:'center' },
  genreChip:     { borderRadius:6, borderWidth:1, paddingHorizontal:6, paddingVertical:1 },
  genreChipText: { fontSize:10, fontWeight:'700' },
  priceText:     { color:GOLD, fontSize:12, fontWeight:'700' },
});

const NoticeDetailView = ({ item, onBack, isSuperAdmin, onEdit, onDelete }) => {
  if (!item) return null;

  // 78차 16차: PICK 카드(item.isStoreEvent)는 더 이상 이 상세 화면을 거치지 않고
  // 카드 탭 즉시 테마 상세(예약 화면)로 바로 이동함(renderItem 참고) — 그 경로 자체를
  // 없애 "상세 내용 없이 바로 예약"으로 단순화했으므로 이 컴포넌트는 공지/앱소식 전용.
  const meta = TYPE_META[item.type] || TYPE_META.notice;
  // 78차: 수정/삭제를 본문 하단 큰 버튼에서 헤더 우측 상단의 작은 아이콘 버튼으로 이동
  return (
    <View style={dv.container}>
      <AppHeader
        showBack onBackPress={onBack}
        centerElement={<Text style={{ color: COLORS.text, fontSize: 15, fontWeight: '800' }} numberOfLines={1}>{meta.label}</Text>}
        rightElement={isSuperAdmin ? (
          <View style={dv.headerAdminBtns}>
            <TouchableOpacity onPress={onEdit} hitSlop={{ top:8, bottom:8, left:8, right:8 }} style={dv.headerAdminBtn}>
              <EditIcon size={16} color={COLORS.gold} />
            </TouchableOpacity>
            <TouchableOpacity onPress={onDelete} hitSlop={{ top:8, bottom:8, left:8, right:8 }} style={dv.headerAdminBtn}>
              <TrashIcon size={16} color={COLORS.red} />
            </TouchableOpacity>
          </View>
        ) : undefined}
      />
      <ScrollView contentContainerStyle={dv.inner} showsVerticalScrollIndicator={false}>
        <View style={[dv.typeBadge, { backgroundColor:meta.color+'22', borderColor:meta.color+'55' }]}>
          {meta.Icon
            ? <IconLabel Icon={meta.Icon} size={12} color={meta.color} textStyle={[dv.typeBadgeText, { color:meta.color }]}>{meta.label}</IconLabel>
            : <Text style={[dv.typeBadgeText, { color:meta.color }]}>{meta.icon} {meta.label}</Text>}
        </View>
        <Text style={dv.title}>{item.title}</Text>
        <Text style={dv.date}>{formatDate(item.createdAt)}</Text>
        {/* 78차 63차: 포스터를 업로드해도 상세 화면 어디에도 안 보이던 버그 — 본문 위에 노출 */}
        {item.posterImageUrl ? (
          <Image source={{ uri: item.posterImageUrl }} style={dv.poster} contentFit="contain" />
        ) : null}
        <View style={dv.divider} />
        <Text style={dv.body}>{item.body || item.summary || '내용이 없습니다.'}</Text>
        {item.link ? (
          <SecondaryButton
            label="🔗 관련 링크 열기"
            onPress={() => Linking.openURL(item.link).catch(()=>{})}
            style={dv.linkBtn}
            textStyle={dv.linkBtnText}
          />
        ) : null}
      </ScrollView>
    </View>
  );
};
const dv = StyleSheet.create({
  container: { flex:1, backgroundColor:BG },
  inner:     { padding:20, paddingBottom:60 },
  typeBadge: { alignSelf:'flex-start', borderRadius:6, borderWidth:1, paddingHorizontal:10, paddingVertical:4, marginBottom:14 },
  typeBadgeText: { fontSize:12, fontWeight:'700' },
  title:     { color:TEXT, fontSize:20, fontWeight:'900', lineHeight:28, marginBottom:8 },
  date:      { color:TEXT_MUTED, fontSize:12, marginBottom:18 },
  poster:    { width:'100%', aspectRatio: 3/4, borderRadius:12, backgroundColor:SURFACE, marginBottom:18 },
  divider:   { height:1, backgroundColor:BORDER, marginBottom:20 },
  body:      { color:TEXT_SEC, fontSize:15, lineHeight:24 },
  linkBtn:   { marginTop:28 },
  linkBtnText:{ fontSize:14 },
  headerAdminBtns: { flexDirection:'row', gap:14 },
  headerAdminBtn:  { padding:2 },
  headerAdminBtnText: { fontSize:16 },
});

// 78차 62차: 매장 이벤트 포스터 첨부용 — SuperAdminStoresScreen.js의 uploadImageAsync와
// 동일 패턴(압축 후 업로드). 포스터는 이미 완성된 디자인이라 4:3 등 강제 크롭 없이 원본 그대로.
async function compressPosterAsync(uri) {
  try {
    const result = await ImageManipulator.manipulateAsync(
      uri, [{ resize: { width: 1200 } }],
      { compress: 0.85, format: ImageManipulator.SaveFormat.JPEG }
    );
    return result.uri;
  } catch (e) {
    return uri;
  }
}
// 78차 50차: storage.rules의 notices가 로그인 여부만 확인하고 역할 검증이 없어 로그인한
// 아무 유저나 직접 쓸 수 있던 문제 — Storage Rules의 firestore.get() 크로스서비스 조회를
// 먼저 시도했으나 이 프로젝트 환경에서 지원되지 않는 것으로 확인(라이브 테스트로 발견) —
// 업로드/삭제 자체를 Admin SDK 기반 CF(uploadAdminImageCF/deleteAdminImageCF)로 옮기고
// storage.rules의 notices는 write:false로 완전 차단.
async function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(',')[1]);
    reader.onerror = () => reject(new Error('이미지 인코딩 실패'));
    reader.readAsDataURL(blob);
  });
}

async function uploadPosterAsync(uri) {
  const compressed = await compressPosterAsync(uri);
  const blob = await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => resolve(xhr.response);
    xhr.onerror = () => reject(new Error('이미지 로드 실패'));
    xhr.responseType = 'blob';
    xhr.open('GET', compressed, true);
    xhr.send(null);
  });
  const imageBase64 = await blobToBase64(blob);
  blob.close && blob.close();
  const cf = httpsCallable(functions, 'uploadAdminImageCF');
  const result = await cf({ prefix: 'notices', imageBase64, contentType: 'image/jpeg' });
  return result.data.url;
}

// 76차: 신규 공지/소식 작성 시 기본 템플릿 — 게시물마다 형식이 제각각이 되는 것을 방지.
// 강제 서식은 아니고 시작점만 제공, 자유롭게 고쳐서 등록 가능.
const NOTICE_TEMPLATES = {
  notice: {
    summary: '공지 내용을 한 줄로 요약해주세요.',
    body: '안녕하세요, UNLOCK 운영팀입니다.\n\n[공지 제목/사유를 입력해주세요]\n\n주요 내용:\n1. \n2. \n3. \n\n이용에 참고 부탁드리며, 궁금하신 점은 고객센터로 문의해주세요. 감사합니다.',
  },
  news: {
    summary: '이번 업데이트/소식을 한 줄로 요약해주세요.',
    body: '주요 업데이트:\n• \n• \n• \n\n지금 바로 앱에서 확인해보세요!',
  },
};

// 78차 60차: 분류(NOTICE_CATEGORIES)를 고르면 제목/요약/본문을 그 분류에 맞는 템플릿으로
// 일부 채워줌 — "신규 매장"/"휴업 안내"는 실제로는 자동 생성(functions/index.js의
// onNewStore/onStoreUpdated)이 담당하므로 수동으로 이 분류를 고르는 일은 드물지만,
// 총관리자가 직접 보완 공지를 쓸 때를 위해 템플릿은 그대로 제공.
const NOTICE_CATEGORY_TEMPLATES = {
  '신규 매장': {
    title: '신규 매장 입점 안내 — [매장명]',
    summary: '[매장명]이(가) UNLOCK에 새롭게 합류했습니다.',
    body: '안녕하세요, UNLOCK 운영팀입니다.\n\n[매장명]이(가) 새롭게 합류했습니다.\n\n위치: [위치]\n테마: [테마명]\n\n테마조회에서 만나보세요.',
  },
  '테마 소식': {
    title: '[매장명] 신규 테마 안내 — [테마명]',
    summary: '[매장명]에 새로운 테마가 등록되었습니다.',
    body: '안녕하세요, UNLOCK 운영팀입니다.\n\n[매장명]에 새 테마 "[테마명]"이(가) 등록되었습니다.\n\n장르: [장르]\n난이도: [난이도]\n\n지금 바로 예약해보세요!',
  },
  '휴업 안내': {
    title: '[매장명] 일시 휴업 안내',
    summary: '[매장명]이(가) 일시 휴업합니다.',
    body: '안녕하세요, UNLOCK 운영팀입니다.\n\n[매장명]이(가) 아래 기간 동안 일시 휴업합니다.\n\n휴업 기간: [시작일] ~ [종료일]\n사유: [사유]\n\n이용에 참고 부탁드립니다.',
  },
  '정책 변경': {
    title: '[정책명] 변경 안내',
    summary: '[적용일]부터 [정책명]이 변경됩니다.',
    body: '안녕하세요, UNLOCK 운영팀입니다.\n\n[적용일]부터 [정책명]이 아래와 같이 변경됩니다.\n\n주요 변경사항:\n1. \n2. \n\n문의사항은 고객센터로 연락 부탁드립니다.',
  },
  '시스템 점검': {
    title: '서버 점검 안내 ([월일] [시작시간]~[종료시간])',
    summary: '시스템 안정화를 위한 정기 점검이 진행됩니다.',
    body: '일시: [월일] [시작시간] ~ [종료시간]\n영향: 앱 전체 서비스 이용 불가\n\n점검 완료 후 정상 서비스가 재개됩니다.',
  },
  '크루 이벤트': {
    title: '[크루명] 크루 이벤트 안내',
    summary: '[크루명] 크루 대상 이벤트를 안내드립니다.',
    body: '안녕하세요, UNLOCK 운영팀입니다.\n\n[크루명] 크루를 대상으로 아래 이벤트를 진행합니다.\n\n이벤트 내용: \n기간: [시작일] ~ [종료일]\n\n많은 참여 부탁드립니다.',
  },
  '이용 안내': {
    title: '[안내 제목]',
    summary: '[한 줄 요약]',
    body: '안녕하세요, UNLOCK 운영팀입니다.\n\n[안내 내용을 입력해주세요]\n\n이용에 참고 부탁드립니다.',
  },
};

// 78차 62차: 매장을 연결하면(연결 매장 선택) 제목/요약/본문을 매장 이벤트용으로 자동 채움 —
// 실제 내용은 첨부한 포스터 이미지가 대신하므로 본문은 짧게. 매장명이 필요해 함수로 분리.
// 78차: 게시 기간 프리셋(30/60/90일) 계산 — UTC 기반 toISOString()은 자정 근처 하루 밀림
// 버그를 유발하는 걸로 이 세션에서 여러 번 확인됐음, 로컬 Y/M/D로 직접 조립.
const addDaysStr = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const storeEventTemplate = (storeName) => ({
  title: `${storeName} 이벤트 안내`,
  summary: '진행 중인 할인/이벤트 소식을 확인해보세요.',
  body: '아래 포스터를 확인해주세요.\n\n자세한 내용 및 참여 방법은 매장에 문의해주세요.',
});

// 75차: 총괄관리자 공지·소식 작성 모달
// 78차 62차: 매장 이벤트 포스터를 총괄관리자가 대신 등록해주는 방식으로 확정 —
// (1) 연결 매장 선택(선택, 정하면 그 매장 상세 화면 상단 "이벤트" 섹션에도 노출),
// (2) 포스터 이미지 첨부(선택), (3) 게시 기간(영구 또는 종료일 지정) 추가.
const WriteNoticeModal = ({ visible, defaultType, editingItem, onClose, onDone }) => {
  const [type,    setType]    = useState(defaultType);
  const [title,   setTitle]   = useState('');
  const [summary, setSummary] = useState('');
  const [body,    setBody]    = useState('');
  const [link,    setLink]    = useState('');
  const [pinned,  setPinned]  = useState(false);
  const [saving,  setSaving]  = useState(false);
  // 78차 59차: "공지" 배지 옆 대분류 배지(선택, 단일선택) — notice 타입 전용
  const [category, setCategory] = useState(null);

  // 78차 62차: 매장 연결
  const [storeList, setStoreList] = useState([]);
  const [storeSearch, setStoreSearch] = useState('');
  const [linkedStoreId, setLinkedStoreId] = useState(null);
  const [linkedStoreName, setLinkedStoreName] = useState('');
  // 78차 62차: 포스터 이미지
  const [posterLocalUri, setPosterLocalUri] = useState('');
  const [posterImageUrl, setPosterImageUrl] = useState('');
  const [uploadingPoster, setUploadingPoster] = useState(false);
  // 78차 62차: 게시 기간 — 기본 영구, 끄면 종료일 지정(비워두면 즉시 만료 취급되지 않도록 저장 시 검증)
  const [isPermanent, setIsPermanent] = useState(true);
  const [endDate, setEndDate] = useState('');

  // 78차 63차: editingItem이 있으면 수정 모드 — 기존 값으로 채운다.
  useEffect(() => {
    if (visible) {
      if (editingItem) {
        setType(editingItem.type === 'news' ? 'news' : 'notice');
        setTitle(editingItem.title || '');
        setSummary(editingItem.summary || '');
        setBody(editingItem.body || '');
        setLink(editingItem.link || '');
        setPinned(!!editingItem.pinned);
        setCategory(editingItem.category || null);
        setStoreSearch('');
        setLinkedStoreId(editingItem.storeId || null);
        setLinkedStoreName(''); // 아래 storeList 로드 후 별도 effect가 채움(notices엔 storeName을 안 저장해서)
        setPosterLocalUri('');
        setPosterImageUrl(editingItem.posterImageUrl || '');
        setIsPermanent(!editingItem.expiresAt);
        setEndDate(editingItem.expiresAt ? String(editingItem.expiresAt).slice(0, 10) : '');
      } else {
        setType(defaultType); setTitle('');
        setSummary(NOTICE_TEMPLATES[defaultType].summary);
        setBody(NOTICE_TEMPLATES[defaultType].body);
        setLink(''); setPinned(false); setCategory(null);
        setStoreSearch(''); setLinkedStoreId(null); setLinkedStoreName('');
        setPosterLocalUri(''); setPosterImageUrl('');
        setIsPermanent(true); setEndDate('');
      }
      getAllStores().then(setStoreList).catch(() => setStoreList([]));
    }
  }, [visible, defaultType, editingItem]);

  // 78차 63차: notices 문서엔 storeName을 안 저장해서(storeId만) 수정 모드 진입 시
  // 연결된 매장 이름을 storeList에서 찾아 채움.
  useEffect(() => {
    if (editingItem?.storeId && storeList.length > 0 && !linkedStoreName) {
      const found = storeList.find(s => s.id === editingItem.storeId);
      if (found) setLinkedStoreName(found.ownerName || '');
    }
  }, [editingItem, storeList]);

  // 76차: 아직 템플릿 그대로(pristine)일 때만 타입 전환 시 새 템플릿으로 갈아끼움 —
  // 이미 내용을 고친 경우엔 실수로 작성 내용을 날리지 않도록 그대로 둠.
  // 78차 63차: 수정 모드에선 기존 내용을 템플릿으로 갈아끼우면 안 되므로 항상 false 취급
  const isPristine = !editingItem && summary === NOTICE_TEMPLATES[type]?.summary && body === NOTICE_TEMPLATES[type]?.body;
  const handleTypeChange = (nextType) => {
    if (isPristine) {
      setSummary(NOTICE_TEMPLATES[nextType].summary);
      setBody(NOTICE_TEMPLATES[nextType].body);
    }
    setType(nextType);
  };
  const handleLoadTemplate = () => {
    setSummary(NOTICE_TEMPLATES[type].summary);
    setBody(NOTICE_TEMPLATES[type].body);
  };

  // 78차 61차: 78차60차 최초 구현은 "아무것도 안 쓴(isPristine, notice 기본템플릿과
  // 일치) 상태일 때만" 채우는 조건이라, 분류A를 골라 템플릿이 채워진 다음(그 순간부터
  // summary/body가 기본템플릿과 달라짐) 곧바로 분류B로 바꾸면 두 번째 템플릿은 전혀
  // 채워지지 않는 버그가 있었음(칩은 B가 선택된 것처럼 보이는데 내용은 A 템플릿 그대로
  // 남는 값 불일치) — "지금 내용이 (기본템플릿) 또는 (직전에 고른 분류의 템플릿)과
  // 정확히 일치하는가"로 판정을 넓혀, 사용자가 아직 아무것도 직접 고치지 않은 한
  // 분류를 몇 번을 바꿔도 항상 최신 템플릿으로 갈아끼워지게 함.
  const matchesCategoryTemplate = (cat) => {
    const tpl = cat && NOTICE_CATEGORY_TEMPLATES[cat];
    return !!tpl && title === tpl.title && summary === tpl.summary && body === tpl.body;
  };
  const handleCategorySelect = (nextCat) => {
    const tpl = nextCat && NOTICE_CATEGORY_TEMPLATES[nextCat];
    if (tpl && !editingItem && (!title.trim() && isPristine || matchesCategoryTemplate(category))) {
      setTitle(tpl.title); setSummary(tpl.summary); setBody(tpl.body);
    }
    setCategory(nextCat);
  };

  // 78차 62차: 매장 선택 시 아직 아무것도 안 고친(pristine) 상태면 매장 이벤트용 템플릿으로 자동 교체
  const handlePickStore = (store) => {
    setLinkedStoreId(store.id);
    setLinkedStoreName(store.ownerName || '');
    if (isPristine && !title.trim()) {
      const tpl = storeEventTemplate(store.ownerName || '매장');
      setTitle(tpl.title); setSummary(tpl.summary); setBody(tpl.body);
    }
  };
  const handleUnlinkStore = () => { setLinkedStoreId(null); setLinkedStoreName(''); };

  const handlePickPoster = async () => {
    const perm = await ImagePicker.requestMediaLibraryPermissionsAsync();
    if (!perm.granted) { showAlert('권한 필요', '갤러리 접근 권한이 필요합니다.'); return; }
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: false, // 78차 62차: 포스터는 이미 완성된 디자인이라 강제 크롭 안 함
      quality: 0.9,
    });
    if (!result.canceled && result.assets[0]) {
      setPosterLocalUri(result.assets[0].uri);
      setPosterImageUrl('');
    }
  };

  const handleSubmit = async () => {
    if (!title.trim() || !body.trim()) {
      showAlert('입력 필요', '제목과 내용을 모두 입력해주세요.');
      return;
    }
    if (!isPermanent && !endDate.trim()) {
      showAlert('입력 필요', '게시 종료일을 입력하거나 "영구 게시"를 선택해주세요.');
      return;
    }
    setSaving(true);
    try {
      let finalPosterUrl = posterImageUrl;
      if (posterLocalUri) {
        setUploadingPoster(true);
        finalPosterUrl = await uploadPosterAsync(posterLocalUri);
        setUploadingPoster(false);
      }
      const payload = {
        type, title: title.trim(), summary: summary.trim(), body: body.trim(),
        link: link.trim() || null, pinned,
        category: type === 'notice' ? (category || null) : null,
        storeId: linkedStoreId || null,
        posterImageUrl: finalPosterUrl || null,
        expiresAt: isPermanent ? null : `${endDate.trim()}T23:59:59`,
      };
      // 78차 63차: editingItem이 있으면 새로 만들지 않고 그 문서를 수정
      if (editingItem) {
        await updateDoc(doc(db, 'notices', editingItem.id), payload);
      } else {
        await addDoc(collection(db, 'notices'), { ...payload, createdAt: serverTimestamp() });
      }
      onDone();
    } catch (e) {
      setUploadingPoster(false);
      showAlert('오류', (editingItem ? '수정' : '등록') + ' 중 오류가 발생했어요.\n' + e.message);
    } finally { setSaving(false); }
  };

  const filteredStores = storeSearch.trim()
    ? storeList.filter(s => (s.ownerName || '').toLowerCase().includes(storeSearch.trim().toLowerCase()))
    : storeList;

  return (
    <Modal visible={visible} animationType="slide" onRequestClose={onClose}>
      <View style={s.container}>
        <AppHeader
          centerElement={<Text style={wn.headerTitle}>{editingItem ? '공지·소식 수정' : '공지·소식 작성'}</Text>}
          rightElement={<TextButton label="✕ 닫기" onPress={onClose} textStyle={wn.closeBtn} style={{ alignSelf: 'flex-end' }} />}
        />
        <ScrollView contentContainerStyle={wn.body}>
          <View style={wn.typeRow}>
            {[{k:'notice',l:'📢 공지사항'},{k:'news',l:'📰 앱 소식'}].map(t=>(
              <TouchableOpacity key={t.k} style={[wn.typeChip, type===t.k && wn.typeChipOn]} onPress={()=>handleTypeChange(t.k)}>
                <Text style={[wn.typeChipText, type===t.k && wn.typeChipTextOn]}>{t.l}</Text>
              </TouchableOpacity>
            ))}
          </View>

          {/* 78차 59차: "공지" 배지 옆에 붙는 대분류(선택, 단일선택) — 공지사항 타입 전용 */}
          {type === 'notice' && (
            <View style={{ marginBottom: 14 }}>
              <Text style={wn.label}>분류 (선택 — 고르면 제목/내용이 템플릿으로 채워져요)</Text>
              <ScrollView horizontal showsHorizontalScrollIndicator={false}
                contentContainerStyle={{ gap: 6, alignItems: 'center' }}>
                <TouchableOpacity style={[wn.catChip, !category && wn.catChipOn]} onPress={() => handleCategorySelect(null)}>
                  <Text style={[wn.catChipText, !category && wn.catChipTextOn]}>없음</Text>
                </TouchableOpacity>
                {NOTICE_CATEGORIES.map(c => (
                  <TouchableOpacity key={c} style={[wn.catChip, category === c && wn.catChipOn]} onPress={() => handleCategorySelect(c)}>
                    <Text style={[wn.catChipText, category === c && wn.catChipTextOn]}>{c}</Text>
                  </TouchableOpacity>
                ))}
              </ScrollView>
            </View>
          )}

          {/* 78차 62차: 매장 연결 — 공지사항 타입일 때만(앱 소식은 플랫폼 전체 공지라 매장 연결 대상 아님) */}
          {type === 'notice' && (
            <View style={{ marginBottom: 14 }}>
              <Text style={wn.label}>연결 매장 (선택 — 정하면 그 매장 페이지에도 노출)</Text>
              {linkedStoreId ? (
                <View style={wn.linkedStoreRow}>
                  <IconLabel Icon={MenuStoreIcon} size={13} color={GOLD} textStyle={wn.linkedStoreText}>{linkedStoreName}</IconLabel>
                  <TextButton label="연결 해제" onPress={handleUnlinkStore} textStyle={{ fontSize: 12 }} />
                </View>
              ) : (
                <>
                  <TextInput style={wn.input} value={storeSearch} onChangeText={setStoreSearch}
                    placeholder="매장명 검색" placeholderTextColor={TEXT_MUTED} />
                  <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ marginTop: 8 }}
                    contentContainerStyle={{ gap: 6, alignItems: 'center' }}>
                    {filteredStores.slice(0, 30).map(st => (
                      <TouchableOpacity key={st.id} style={wn.storeChip} onPress={() => handlePickStore(st)}>
                        <Text style={wn.storeChipText} numberOfLines={1}>{st.ownerName}</Text>
                      </TouchableOpacity>
                    ))}
                    {filteredStores.length === 0 && (
                      <Text style={{ color: TEXT_MUTED, fontSize: 12 }}>검색 결과가 없어요.</Text>
                    )}
                  </ScrollView>
                </>
              )}
            </View>
          )}
          <Text style={wn.label}>제목</Text>
          <TextInput style={wn.input} value={title} onChangeText={setTitle} placeholder="제목을 입력해주세요" placeholderTextColor={TEXT_MUTED} />
          <Text style={wn.label}>요약 (목록에 짧게 표시)</Text>
          <TextInput style={wn.input} value={summary} onChangeText={setSummary} placeholder="한 줄 요약 (선택)" placeholderTextColor={TEXT_MUTED} />
          <View style={{flexDirection:'row', justifyContent:'space-between', alignItems:'center'}}>
            <Text style={wn.label}>내용</Text>
            <TextButton label="📋 템플릿 불러오기" onPress={handleLoadTemplate} textStyle={{ fontSize:12 }} />
          </View>
          <TextInput style={[wn.input, wn.textarea]} value={body} onChangeText={setBody} placeholder="본문 내용을 입력해주세요" placeholderTextColor={TEXT_MUTED} multiline />
          <Text style={wn.label}>관련 링크 (선택)</Text>
          <TextInput style={wn.input} value={link} onChangeText={setLink} placeholder="https://..." placeholderTextColor={TEXT_MUTED} autoCapitalize="none" />

          {/* 78차 62차: 포스터 이미지 첨부 — 매장이 쓰는 실제 이벤트 포스터를 그대로 등록 */}
          <Text style={wn.label}>포스터 이미지 (선택)</Text>
          {(posterLocalUri || posterImageUrl) ? (
            <View style={{ marginBottom: 14 }}>
              <Image source={{ uri: posterLocalUri || posterImageUrl }} style={wn.posterPreview} contentFit="contain" />
              <TextButton label="🗑 이미지 제거" onPress={() => { setPosterLocalUri(''); setPosterImageUrl(''); }} textStyle={{ fontSize: 12, color: COLORS.red }} />
            </View>
          ) : (
            <SecondaryButton label="🖼 갤러리에서 포스터 선택" onPress={handlePickPoster} style={{ marginBottom: 14 }} />
          )}
          {uploadingPoster && <Text style={{ color: TEXT_MUTED, fontSize: 12, marginBottom: 10 }}>이미지 업로드 중...</Text>}

          {/* 78차: 게시 기간 — 30/60/90일 프리셋 + 영구, 필요하면 종료일 직접 수정도 가능 */}
          <Text style={wn.label}>게시 기간</Text>
          <View style={{ flexDirection:'row', gap:8, marginBottom: isPermanent ? 16 : 8 }}>
            {[30, 60, 90].map(days => {
              const preset = addDaysStr(days);
              const active = !isPermanent && endDate === preset;
              return (
                <TouchableOpacity key={days} style={[wn.typeChip, active && wn.typeChipOn]}
                  onPress={() => { setIsPermanent(false); setEndDate(preset); }}>
                  <Text style={[wn.typeChipText, active && wn.typeChipTextOn]}>{days}일</Text>
                </TouchableOpacity>
              );
            })}
            <TouchableOpacity style={[wn.typeChip, isPermanent && wn.typeChipOn]} onPress={() => setIsPermanent(true)}>
              <Text style={[wn.typeChipText, isPermanent && wn.typeChipTextOn]}>♾️ 영구</Text>
            </TouchableOpacity>
          </View>
          {!isPermanent && (
            <>
              <Text style={[wn.label, { marginTop:0 }]}>종료일 (직접 수정 가능)</Text>
              <TextInput style={wn.input} value={endDate} onChangeText={setEndDate}
                placeholder="YYYY-MM-DD" placeholderTextColor={TEXT_MUTED} />
            </>
          )}

          <TouchableOpacity style={wn.pinnedRow} onPress={()=>setPinned(p=>!p)}>
            <View style={[wn.checkbox, pinned && wn.checkboxOn]}>{pinned && <CheckmarkIcon size={12} color="#0a0a14" />}</View>
            <IconLabel Icon={CrewNoticeIcon} size={13} color={TEXT} textStyle={wn.pinnedLabel}>상단 고정</IconLabel>
          </TouchableOpacity>
          <GradientButton
            label={saving ? (editingItem ? '수정 중...' : '등록 중...') : (editingItem ? '수정하기' : '등록하기')}
            onPress={handleSubmit}
            disabled={saving}
          />
        </ScrollView>
      </View>
    </Modal>
  );
};
const wn = StyleSheet.create({
  headerTitle:  { color:TEXT, fontSize:16, fontWeight:'800' },
  closeBtn:     { color:TEXT_MUTED, fontSize:14 },
  body:         { padding:16, paddingBottom:60 },
  typeRow:      { flexDirection:'row', gap:8, marginBottom:16 },
  typeChip:     { flex:1, alignItems:'center', paddingVertical:10, borderRadius:10, borderWidth:1, borderColor:BORDER, backgroundColor:SURFACE },
  typeChipOn:   { backgroundColor:GOLD+'18', borderColor:GOLD+'55' },
  typeChipText: { color:TEXT_MUTED, fontSize:13, fontWeight:'600' },
  typeChipTextOn:{ color:GOLD, fontWeight:'800' },
  label:        { color:TEXT_MUTED, fontSize:12, marginBottom:6, marginTop:4 },
  input:        { backgroundColor:SURFACE, borderWidth:1, borderColor:BORDER, borderRadius:10, paddingHorizontal:14, height:46, color:TEXT, fontSize:14, marginBottom:14 },
  textarea:     { height:160, paddingVertical:12, textAlignVertical:'top' },
  pinnedRow:    { flexDirection:'row', alignItems:'center', gap:10, marginBottom:24 },
  checkbox:     { width:20, height:20, borderRadius:5, borderWidth:2, borderColor:TEXT_MUTED, alignItems:'center', justifyContent:'center' },
  checkboxOn:   { backgroundColor:GOLD, borderColor:GOLD },
  pinnedLabel:  { color:TEXT, fontSize:14 },
  // 78차 62차: 매장 연결 / 포스터 이미지
  linkedStoreRow: { flexDirection:'row', alignItems:'center', justifyContent:'space-between',
    backgroundColor:SURFACE, borderWidth:1, borderColor:GOLD+'55', borderRadius:10, paddingHorizontal:14, paddingVertical:12 },
  linkedStoreText: { color:GOLD, fontSize:14, fontWeight:'700' },
  storeChip:    { paddingHorizontal:12, paddingVertical:7, borderRadius:16, borderWidth:1, borderColor:BORDER, backgroundColor:SURFACE, maxWidth:160 },
  storeChipText:{ color:TEXT_MUTED, fontSize:12 },
  // 78차 60차: 분류 칩 — wn.typeChip(flex:1, 2버튼 고정폭 전용)을 가로 스크롤에 억지로
  // 끼워쓰다 글자가 세로로 눌려 보이던 버그(스크린샷 재신고) — storeChip과 동일한
  // padding 기반 전용 스타일로 분리.
  catChip:      { paddingHorizontal:12, paddingVertical:7, borderRadius:16, borderWidth:1, borderColor:BORDER, backgroundColor:SURFACE },
  catChipOn:    { backgroundColor:GOLD+'18', borderColor:GOLD+'55' },
  catChipText:  { color:TEXT_MUTED, fontSize:12, fontWeight:'600' },
  catChipTextOn:{ color:GOLD, fontWeight:'800' },
  posterPreview:{ width:'100%', height:220, borderRadius:10, backgroundColor:SURFACE, marginBottom:8 },
});

export default function EventsScreen() {
  // 74차: PICK을 예약 탭의 기본 화면으로 옮기면서, 일반 고객이 마이 탭에서 들어오는
  // 경로(navigate('Events', {hidePick:true}))에서는 PICK 탭을 뺌. 총괄관리자 전용 탭
  // (SuperAdminTabNavigator)은 파라미터 없이 그대로 진입하므로 기존처럼 PICK이 보임 —
  // 총괄관리자가 PICK 등록 현황을 모니터링하는 용도는 유지.
  const route = useRoute();
  const navigation = useNavigation();
  // 80차 후속: [버그 수정, 전수조사로 발견] 이 화면은 SuperAdminTabNavigator엔 Tab.Screen
  // 으로, 일반 AppStack엔 Stack.Screen("공지사항" 메뉴/알림 딥링크 진입)으로 이중 등록돼
  // 있음(navigation/index.js) — 아래 "작성" FAB이 하드코딩 bottom:20이라, 앱 자체 탭바가
  // 없는 Stack 경로로 총관리자가 들어오면(예: 마이 탭 "공지사항") 안드로이드 시스템
  // 내비게이션 바에 가려질 수 있었음(RecruitDetailScreen.js와 동일 유형) —
  // useBottomSafePadding(공용, src/hooks/)이 탭/스택 여부를 판별해 Tab 경로는 기존값을,
  // Stack 경로만 시스템 내비바 여백을 더해줌.
  const fabBottom = useBottomSafePadding(20);
  const { adminRole, profile } = useAuth();
  // 80차 후속: [버그 수정, fork로 발견] PICK 카드는 "19금" 배지만 달아뒀을 뿐, RecruitScreen.js/
  // CrewScreen.js와 달리 확인된 미성년자에게 실제로 숨기는 필터가 없었음 — 썸네일·테마명·
  // 매장명이 그대로 노출되고 있었음(같은 세션에서 이미 고친 크루 피드 노출 버그와 동일한 클래스).
  const isMinorViewer = isConfirmedMinorBirth(profile?.birth);
  const isSuperAdmin = adminRole === 'super'; // 75차: 공지·소식 작성 버튼 노출 여부
  const hidePick = route.params?.hidePick === true;
  const visibleTabs = hidePick ? TABS.filter(t => t.key !== 'event') : TABS;

  const [activeTab,    setActiveTab]    = useState(hidePick ? 'notice' : 'event');
  const [notices,      setNotices]      = useState({ notice:[], news:[] });
  const [storeEvents,  setStoreEvents]  = useState([]); // 68차: BOOST 매장 이벤트(PICK)
  const [loading,      setLoading]      = useState(true);
  const [refreshing,   setRefreshing]   = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showWrite,    setShowWrite]    = useState(false); // 75차: 공지·소식 작성 모달
  const [editingItem,  setEditingItem]  = useState(null); // 78차 63차: 수정 모드 대상

  // 78차 63차: 삭제(총괄관리자 전용) — 확인 후 notices 문서 삭제, 포스터가 있으면
  // Storage에서도 best-effort로 함께 정리(실패해도 문서 삭제 자체는 진행).
  // 78차: react-native-web의 Alert.alert()는 빈 no-op(static alert(){})이라 웹 배포본에서는
  // 확인 다이얼로그 자체가 안 뜨고 조용히 아무 일도 안 일어나고 있었음(카드 목록 삭제 버튼을
  // 눌러도 반응이 없다는 신고로 발견 — 상세화면 삭제 버튼도 78차63차부터 동일하게 웹에서
  // 계속 broken 상태였을 것) — 앱 자체 웹 호환 모달(showAlert, AppAlert.js)로 교체.
  const handleDeleteNotice = (item) => {
    showAlert('삭제', '이 공지를 삭제하시겠어요? 되돌릴 수 없습니다.', [
      { text: '취소', style: 'cancel' },
      { text: '삭제', style: 'destructive', onPress: async () => {
        try {
          await deleteDoc(doc(db, 'notices', item.id));
          if (item.posterImageUrl) {
            const match = item.posterImageUrl.match(/notices%2F([^?]+)/);
            if (match) {
              // 78차 50차: notices Storage 쓰기/삭제가 이제 클라이언트에서 완전히 막혀있어
              // (write:false) deleteAdminImageCF(Admin SDK) 경유로 변경.
              httpsCallable(functions, 'deleteAdminImageCF')({
                prefix: 'notices', fileName: decodeURIComponent(match[1]),
              }).catch(() => {});
            }
          }
          setSelectedItem(null);
          load();
        } catch (e) {
          showAlert('오류', '삭제 중 오류가 발생했어요.\n' + e.message);
        }
      }},
    ]);
  };

  // 79차: 탭을 빠르게 오가면 이전 포커스의 load()가 늦게 응답해 최신 목록을 오래된
  // 것으로 덮어쓸 수 있었음(MyReviewsScreen.js가 74차에 막아둔 것과 동일 위험) —
  // activeRef로 이전 포커스 세션의 setState만 무시.
  const activeRef = useRef(true);
  const load = useCallback(async () => {
    try {
      await seedIfEmpty();
      const [snap, boostEvents] = await Promise.all([
        getDocs(query(collection(db,'notices'), orderBy('createdAt','desc'), limit(60))),
        hidePick ? Promise.resolve([]) : getActivePickStoreEvents(),
      ]);
      if (!activeRef.current) return;
      // 74차: expiresAt 지난 공지는 목록에서 제외 (onNewStore가 생성하는 신규 매장
      // 안내가 30일 후 자동으로 없어지도록) — expiresAt 없는 기존 공지는 그대로 계속 노출
      // 79차: [버그 수정] expiresAt 형식이 두 가지가 섞여 있음 — functions/index.js의
      // onNewStore(서버, "신규 매장" 자동공지)는 `new Date(...).toISOString()`(UTC, Z 포함)로,
      // WriteNoticeModal(이 화면, 수동 작성)은 `${endDate}T23:59:59`(로컬 KST 벽시계, Z 없음)로
      // 저장 — 기존엔 이걸 `new Date().toISOString()`(UTC)과 문자열 비교해서, 로컬(Z 없는)
      // 형식 쪽은 자정~오전9시(KST) 사이 최대 9시간 더 노출되는 버그가 있었음(전수 정독으로
      // 발견). 문자열 비교 대신 Date 객체로 파싱해서 비교 — JS는 "Z"가 있으면 UTC로, 없으면
      // 로컬로 해석해 두 형식 모두 실제 절대시각 기준으로 정확히 비교됨.
      const now = new Date();
      const all  = snap.docs
        .map(d => ({ id:d.id, ...d.data() }))
        .filter(n => !n.expiresAt || new Date(n.expiresAt) > now);
      const sorted = [...all].sort((a,b) => {
        if (a.pinned && !b.pinned) return -1;
        if (!a.pinned && b.pinned) return 1;
        return 0;
      });
      // 72차: 공지사항 = 포인트 부여 이벤트·신규 매장 안내 등 플랫폼 공지 — 기존 'event'
      // 타입(포인트/할인 등 혜택성 공지)을 여기로 흡수. PICK 탭은 BOOST 매장 PICK 전용으로 분리.
      setNotices({
        notice: sorted.filter(n => n.type==='notice' || n.type==='event' || !n.type),
        news:   sorted.filter(n => n.type==='news'),
      });
      // 68차: BOOST 매장 PICK은 최신 등록순으로 PICK 탭 상단에 노출
      setStoreEvents(
        [...boostEvents]
          .sort((a,b) => (b.createdAt?.toDate?.() || new Date(b.createdAt||0)) - (a.createdAt?.toDate?.() || new Date(a.createdAt||0)))
          .map(e => ({ ...e, isStoreEvent: true }))
      );
    } catch {}
    finally { if (activeRef.current) { setLoading(false); setRefreshing(false); } }
  }, [hidePick]);

  // 78차 39차: 이 화면이 총괄관리자에게는 하단 탭("공지·소식", 리마운트 안 됨)이라 —
  // 다른 탭에서 매장이 새 PICK을 등록해도 이 탭으로 돌아왔을 때 마운트 1회성
  // useEffect로는 반영이 안 되던 것(BookingScreen.js/HomeScreen.js와 동일한 버그 클래스).
  useFocusEffect(useCallback(() => {
    activeRef.current = true;
    load();
    return () => { activeRef.current = false; };
  }, [load]));

  // 72차: 'PICK' 탭(key: 'event')은 BOOST 매장이 등록한 PICK 테마만 노출 —
  // 일반 앱 혜택 공지(구 type:'event')는 공지사항 탭으로 흡수했으므로 더 이상 섞지 않음
  const currentList = activeTab === 'event'
    ? storeEvents.filter(e => !(isMinorViewer && e.isAdultOnly))
    : (notices[activeTab] || []);

  if (selectedItem) return (
    <View style={s.container}>
      <NoticeDetailView
        item={selectedItem}
        onBack={() => setSelectedItem(null)}
        isSuperAdmin={isSuperAdmin}
        onEdit={() => { setEditingItem(selectedItem); setShowWrite(true); }}
        onDelete={() => handleDeleteNotice(selectedItem)}
      />
      <WriteNoticeModal
        visible={showWrite}
        defaultType={selectedItem.type === 'news' ? 'news' : 'notice'}
        editingItem={editingItem}
        onClose={() => { setShowWrite(false); setEditingItem(null); }}
        onDone={() => { setShowWrite(false); setEditingItem(null); setSelectedItem(null); load(); }}
      />
    </View>
  );

  return (
    <View style={s.container}>
      {/* 74차: 마이 탭에서 진입할 때만 뒤로가기 버튼 노출 — canGoBack()은 상위 스택 전체를
          훑어서 신뢰할 수 없다는 게 RecruitScreen.js에서 이미 확인됨(74차), 그래서 여기는
          route.params로 명시적으로 받음 */}
      {/* 78차 38차: 홈 탭의 "PICK·공지" 버튼(hidePick 없음, PICK 탭 포함)으로 들어왔을 때도
          헤더가 항상 "공지·소식"이라고만 떠서 실제 진입 경로/라벨과 안 맞던 버그 —
          hidePick(마이 탭 "공지·소식" 메뉴 전용, PICK 탭 자체가 없음) 여부로 제목을 분기 */}
      <AppHeader
        showBack={route.params?.showBack === true}
        centerElement={route.params?.showBack === true ? <Text style={{ color: COLORS.text, fontSize: 15, fontWeight: '800' }}>{hidePick ? '공지·소식' : 'PICK·공지'}</Text> : undefined}
        rightElement={isSuperAdmin ? <RoleBadge role="super" /> : undefined}
      />
      <View style={s.tabRow}>
        {visibleTabs.map(tab => (
          <TouchableOpacity key={tab.key} style={[s.tab, activeTab===tab.key && s.tabActive]} onPress={() => setActiveTab(tab.key)}>
            {tab.Icon
              ? <IconLabel Icon={tab.Icon} size={13} color={activeTab===tab.key ? s.tabTextActive.color : s.tabText.color} textStyle={[s.tabText, activeTab===tab.key && s.tabTextActive]}>{tab.label}</IconLabel>
              : <Text style={[s.tabText, activeTab===tab.key && s.tabTextActive]}>{tab.icon} {tab.label}</Text>}
          </TouchableOpacity>
        ))}
      </View>
      <View style={s.tabUnderline}>
        <View style={[s.tabIndicator, { left:`${visibleTabs.findIndex(t=>t.key===activeTab)*(100/visibleTabs.length)}%`, width:`${100/visibleTabs.length}%` }]} />
      </View>
      {loading ? <LoadingOverlay inline /> : (
        <FlatList
          data={currentList} keyExtractor={item=>item.id}
          contentContainerStyle={s.list} showsVerticalScrollIndicator={false}
          refreshControl={<RefreshControl refreshing={refreshing} onRefresh={()=>{ setRefreshing(true); load(); }} tintColor={GOLD} />}
          renderItem={({ item }) => (
            item.isStoreEvent
              // 78차 16차: PICK 카드는 상세 화면 없이 탭 즉시 테마 상세(예약 화면)로 이동
              // (ThemeDetailScreen이 id만 받으면 전체 데이터를 재조회하도록 이미 돼있어
              // 여기서 product 객체를 새로 만들 필요 없음)
              ? <StoreEventCard item={item} onPress={(it) => navigation.navigate('ThemeDetail', { product: { id: it.productId } })} />
              : <NoticeCard
                  item={item} onPress={setSelectedItem}
                  isSuperAdmin={isSuperAdmin}
                  onEdit={(it) => { setEditingItem(it); setShowWrite(true); }}
                  onDelete={handleDeleteNotice}
                />
          )}
          ListEmptyComponent={
            <View style={s.empty}>
              {activeTab==='notice' ? <MenuNoticeIcon size={48} color={COLORS.gold} />
                : activeTab==='news' ? <Text style={s.emptyIcon}>📰</Text>
                : <SpotlightStarIcon size={48} color={COLORS.gold} />}
              <Text style={s.emptyTitle}>
                {activeTab==='notice'?'등록된 공지사항이 없습니다.':activeTab==='news'?'등록된 소식이 없습니다.':'등록된 PICK이 없습니다.'}
              </Text>
              <Text style={s.emptyDesc}>새 소식이 생기면 이곳에 표시됩니다.</Text>
            </View>
          }
        />
      )}

      {/* 75차: 총괄관리자 전용 공지·소식 작성 버튼 (PICK 탭은 매장이 직접 등록하므로 제외) */}
      {isSuperAdmin && activeTab !== 'event' && (
        <TouchableOpacity
          style={[s.fab, { bottom: fabBottom }]}
          onPress={() => setShowWrite(true)}
        >
          <IconLabel Icon={EditIcon} size={14} color={s.fabText.color || '#0a0a14'} textStyle={s.fabText}>작성</IconLabel>
        </TouchableOpacity>
      )}
      <WriteNoticeModal
        visible={showWrite}
        defaultType={editingItem ? (editingItem.type === 'news' ? 'news' : 'notice') : (activeTab === 'news' ? 'news' : 'notice')}
        editingItem={editingItem}
        onClose={() => { setShowWrite(false); setEditingItem(null); }}
        onDone={() => { setShowWrite(false); setEditingItem(null); load(); }}
      />
    </View>
  );
}

const s = StyleSheet.create({
  container:     { flex:1, backgroundColor:BG },
  tabRow:        { flexDirection:'row', paddingHorizontal:16, paddingTop:14, gap:4 },
  tab:           { flex:1, alignItems:'center', paddingVertical:10, borderRadius:10, backgroundColor:SURFACE },
  tabActive:     { backgroundColor:GOLD+'18' },
  tabText:       { color:TEXT_MUTED, fontSize:12, fontWeight:'600' },
  tabTextActive: { color:GOLD, fontWeight:'800' },
  tabUnderline:  { height:2, backgroundColor:BORDER, marginHorizontal:16, marginTop:8, marginBottom:12, borderRadius:1, position:'relative' },
  tabIndicator:  { position:'absolute', top:0, width:'33.33%', height:2, backgroundColor:GOLD, borderRadius:1 },
  list:          { paddingHorizontal:16, paddingBottom:32, paddingTop:4 },
  empty:         { alignItems:'center', marginTop:80, gap:12 },
  emptyIcon:     { fontSize:48 },
  emptyTitle:    { color:TEXT_SEC, fontSize:15, fontWeight:'700', textAlign:'center' },
  emptyDesc:     { color:TEXT_MUTED, fontSize:13, textAlign:'center' },
  fab:           { position:'absolute', right:16, bottom:20, backgroundColor:GOLD, borderRadius:24, paddingHorizontal:18, paddingVertical:12, elevation:6, shadowColor:'#000', shadowOffset:{width:0,height:2}, shadowOpacity:0.3, shadowRadius:6 },
  fabText:       { color:'#0a0a14', fontSize:14, fontWeight:'800' },
});